<template>
  <VcLayout justify-center align-center column>
    <VcEmptyState
      :image="emptyStateImage"
      :title="title"
      :subtitle="subTitle"
      size="sm"
      class="empty-state">
      <template #buttonArea>
        <VcLayout justify-center>
          <VcLink
            :url="'#'"
            :label="linkButtonText"
            target="_self"
            @click.native.prevent="handleClick"
            class="action-link">
          </VcLink>
        </VcLayout>
      </template>
    </VcEmptyState>
  </VcLayout>
</template>

<script>
import ProductSvg from '@/assets/images/payments/empty_state.svg';
import PackageSvg from '@/assets/images/payments/packages_empty_state.svg';

export default {
  components: {
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    linkText: {
      type: String,
      required: false,
    },
    activeTabName: {
      type: String,
      default: 'products',
    },
  },
  computed: {
    emptyStateImage() {
      return this.activeTabName === 'packages' ? PackageSvg : ProductSvg;
    },
    linkButtonText() {
      return this.linkText;
    },
  },
  methods: {
    handleClick() {
      if (this.activeTabName === 'packages') {
        this.$track('Checkout - Add First Package In POS');
        this.$emit('empty-state-click', 'package');
      } else {
        this.$emit('empty-state-click', 'product');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "styles/variables.scss";

  .action-link {
    cursor: pointer;
    text-decoration: none;
    font-size: var(--font-size-x-small);
  }
</style>
